import { useState } from "react";
import { IUserColab } from "../../Interfaces";
import { useUser } from "../../Providers/User";
import { ButtonsContainer } from "../CardColaborators/style";
import { CloseButton } from "../CloseButton";
import { GearButton } from "../GearButton";
import ModalElement from "../Modal";
import { UserForm } from "../UserForm";
import { CollabCard, CollabData } from "./style";

interface ICardColabProps {
  colab: IUserColab;
}

const CardColaborators = ({ colab }: ICardColabProps) => {
  const { name, email } = colab;

  const { admAuth } = useUser();

  const { deleteColab } = useUser();

  const [editModalIsOpen, setEditModalIsOpen] = useState<boolean>(false);

  const handleEditModal = () => {
    setEditModalIsOpen(!editModalIsOpen);
  };
  return (
    <CollabCard>
      <ModalElement isOpen={editModalIsOpen} closeModal={handleEditModal}>
        <UserForm user={colab} />
      </ModalElement>
      <CollabData>
        <div className="Infos">
          <h2>{name}</h2>
          <h3>{email}</h3>
        </div>
      </CollabData>
      <ButtonsContainer>
        <div>
        {admAuth && <GearButton showModal={handleEditModal} />}
        {admAuth && <CloseButton deleteColab={deleteColab} colab={colab} />}
        </div>
      </ButtonsContainer>
    </CollabCard>
  );
};

export default CardColaborators;
